import { _ } from "../../../core/polyglot/polyglot.js";
import { calendarWeekIcon } from "../../../core/elements/icons/index.js";
import AbstractAction from "./AbstractAction.js";

/**
 * Action inserting period value at selection position.
 */
export default class InsertPeriodAction extends AbstractAction {
	getMenuItems({ actionsManager }) {
		return [this._makeInsertPeriodItem({ actionsManager })];
	}

	_makeInsertPeriodItem({ actionsManager }) {
		return this._makeMenuItem({
			order: 90,
			title: _("Insert Period"),
			run: actionsManager.replaceSelectionWithInputValue({
				type: "inputValue_period",
			}),
			icon: this._makeIcon({ cssClass: calendarWeekIcon.getCssClass() }),
		});
	}
}
